// CRA inlines only static `process.env.REACT_APP_*` references, so each value is read explicitly.
const required = (value: string | undefined, name: string): string => {
  if (!value) {
    throw new Error(`Missing environment variable: ${name}`);
  }
  return value;
};

export const ENV = {
  BASE_URL: required(process.env.REACT_APP_BASE_URL, "REACT_APP_BASE_URL"),
  OHC_BASE_URL: required(process.env.REACT_APP_OHC_BASE_URL, "REACT_APP_OHC_BASE_URL"),
  SOCKET_SERVER_URL: required(process.env.REACT_APP_SOCKET_SERVER_URL, "REACT_APP_SOCKET_SERVER_URL"),
  PATIENT_PORTAL: required(process.env.REACT_APP_PATIENT_PORTAL, "REACT_APP_PATIENT_PORTAL"),
  OHC_REDIRECT: required(process.env.REACT_APP_OHC_REDIRECT, "REACT_APP_OHC_REDIRECT"),
  CRYPTO_SECRET_KEY: required(process.env.REACT_APP_CRYPTO_SECRET_KEY, "REACT_APP_CRYPTO_SECRET_KEY"),
  CRYPTO_IV: required(process.env.REACT_APP_CRYPTO_IV, "REACT_APP_CRYPTO_IV"),
};
